<template>
  <div class="orderCenter">
    <div class="orderCenter-top">
      <div class="top-item">团队门票信息</div>
      <div style="height: 0.4rem;"></div>
    </div>

    <div class="orderCenter-bottom">
      <p style="font-size: 0.1rem;">*根据景区规定，每个团队每次最多门票200人</p>

      <div class="blank"></div>

      <el-select v-model="tuanform.place_value" placeholder="请选择您来自哪里" size="medium" style="width: 100%">
        <el-option v-for="item in places" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>

      <div class="blank"></div>

      <el-input v-model="tuanform.input_name"
        @input="tuanform.input_name = tuanform.input_name.replace(/[^\a-\z\A\u4E00-\u9FA5]/g, '')" size="medium"
        placeholder="请输入领队姓名"></el-input>

      <div class="blank"></div>

      <el-select v-model="tuanform.people_num" placeholder="请选择团队人数（包含领队）" size="medium" style="width: 100%">
        <el-option v-for="item in all_num" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>

    <div class="bttom-btn">
      <el-button style="background-color: #2c7272; color: white; width: 90%;" @click="submittuan">确定</el-button>
    </div>
  </div>
</template>
  
  
<script>
export default {
  data() {
    return {
      places: ["上海",
        "江苏", "浙江", "北京", "天津", "河北", "山西", "内蒙古", "辽宁", "吉林", "黑龙江", "安徽", "福建", "江西", "山东", "河南", "湖北", "湖南",
        "广东", "广西", "海南", "重庆", "四川", "贵州", "云南", "西藏", "陕西", "甘肃",
        "青海", "宁夏", "新疆", "台湾", "香港", "澳门", "境外"],     // 地区
      tuanform: {},    // 提交表单
      all_num: [],     // 团队总人数
    }
  },
  mounted() {
    let query = this.$route.query;
    this.appointDate = query.appointDate;
    this.appointTimeEnd = query.appointTimeEnd;
    this.appointTimeStart = query.appointTimeStart;
    this.leftQuantity = query.leftQuantity;
    this.limitCount = query.limitCount;
    this.tourId = query.tourId;
    this.tickets = query.tickets;
    for (let i = 1; i <= 50; i++) {
      this.all_num.push(i);
    }
  },
  methods: {
    submittuan() {
      if (this.limitCount != -1 && this.leftQuantity < this.tuanform.people_num) {
        alert("余票不足");
        return false;
      }
      if (this.tuanform.place_value && this.tuanform.input_name && this.tuanform.people_num) {
        this.$axios.post("/team/userinsert", {
          tourId: this.tourId,
          appointDate: this.appointDate,
          appointTimeStart: this.appointTimeStart,
          appointTimeEnd: this.appointTimeEnd,
          num: this.tuanform.people_num,
          name: this.tuanform.input_name,
          region: this.tuanform.place_value,
        }).then(
          res => {
            if (res.code == 200) {
              this.$router.push("/newOrderCenter");
            } else {
              alert("门票失败")
            }
          }
        ).catch(error => { console.log(error) })
      } else {
        alert("请填写完整信息")
      }
    }
  }
}
</script>
  
<style lang="less" scoped>
.orderCenter {
  font-size: 0.16rem;

  .orderCenter-top {
    width: 100%;
    background-color: #2c7272;
    padding: 0 0.2rem;
    box-sizing: border-box;

    .top-item {
      font-size: 0.22rem;
      color: #fff;
      padding-top: 0.3rem;
    }
  }
}

.orderCenter-bottom {
  background-color: #fff;
  border-top-left-radius: 0.15rem;
  border-top-right-radius: 0.15rem;
  position: relative;
  top: -0.2rem;
  padding: 0.1rem 0.2rem 0 0.2rem;
  box-sizing: border-box;
}

.blank {
  height: 0.2rem;
}

.bttom-btn {
  position: fixed;
  bottom: 0.2rem;
  width: 100%;
  text-align: center;
}
</style>